import type { ReactNode } from 'react'
import { Link } from 'react-router-dom'
import { Bike, ArrowLeft } from 'lucide-react'

interface AuthCardProps {
  title: string
  subtitle: string
  children: ReactNode
  footer?: ReactNode
}

export function AuthCard({ title, subtitle, children, footer }: AuthCardProps) {
  return (
    <div className="min-h-[calc(100vh-200px)] bg-gradient-to-br from-brand-50 via-slate-50 to-brand-100 flex items-center justify-center py-10 px-4">
      <div className="w-full max-w-[460px]">
        <Link to="/" className="inline-flex items-center gap-2 text-sm text-muted hover:text-brand-600 mb-5">
          <ArrowLeft className="w-4 h-4" /> Về trang chủ
        </Link>

        <div className="bg-surface border border-border rounded-2xl shadow-card p-8">
          <div className="flex items-center gap-3 mb-6">
            <div className="w-12 h-12 rounded-xl bg-brand-600 flex items-center justify-center text-white">
              <Bike className="w-7 h-7" />
            </div>
            <div>
              <div className="text-lg font-bold text-brand-700">Xe Điện Việt</div>
              <div className="text-xs text-muted">Di chuyển xanh — Cuộc sống đẹp hơn</div>
            </div>
          </div>

          <h1 className="text-2xl font-bold text-text">{title}</h1>
          <p className="text-sm text-muted mt-1">{subtitle}</p>

          <div className="mt-6">{children}</div>
        </div>

        {footer && <div className="mt-5 text-center text-sm text-muted">{footer}</div>}
      </div>
    </div>
  )
}
